import { render, staticRenderFns } from "./productAccessoryInfo.vue?vue&type=template&id=6de945ee&"
import script from "./productAccessoryInfo.vue?vue&type=script&lang=js&"
export * from "./productAccessoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./productAccessoryInfo.vue?vue&type=style&index=0&id=6de945ee&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports